import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/cajeroDashboard.css";
import useCajeroDashboard from "../hooks/useCajeroDashboard";
import FinancialTab from "../components/FinancialTab";

const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toLocaleString("es-EC");
};

const accentMap = {
  blue: { bg: "#e0ecff", fg: "#1d4ed8" },
  violet: { bg: "#ebe9ff", fg: "#6d28d9" },
  green: { bg: "#e5f8f2", fg: "#0f766e" },
  amber: { bg: "#fff4e0", fg: "#c2410c" },
  aqua: { bg: "#e0f7ff", fg: "#0ea5e9" },
  coral: { bg: "#ffe7e2", fg: "#dc2626" },
};

export default function CajeroDashboard() {
  const {
    data,
    summary,
    loading,
    error,
    centros,
    cursos,
    promociones,
    fetchDashboard,
  } = useCajeroDashboard();

  useEffect(() => {
    fetchDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const financiero = data?.financiero || {
    kpis: [],
    cobranzaDia: [],
    cobranzaMonthly: [],
    metodoPago: [],
    metodoPagoMonthly: [],
    facturas: [],
  };
  const formattedLastUpdate = summary.lastUpdate
    ? `Actualizado: ${new Date(summary.lastUpdate).toLocaleString("es-EC")}`
    : "Sin datos";

  return (
    <div className="dashboard-page management-page management-theme-teal cajero container-fluid py-4">
      <div className="management-card management-header cajero-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Cajero</p>
          <h3 className="management-title mb-1">Tablero financiero</h3>
          <p className="text-muted mb-2">Seguimiento de cobros, métodos y facturacion.</p>
        </div>
        <div className="cajero-header-actions">
          <button className="btn cajero-refresh-btn" type="button" onClick={fetchDashboard} disabled={loading}>
            <i className="bi bi-arrow-repeat me-2" />
            {loading ? "Actualizando..." : "Actualizar"}
          </button>
          <small className="text-muted">{formattedLastUpdate}</small>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger d-flex align-items-center gap-2">
          <i className="bi bi-exclamation-triangle" />
          <span>{error}</span>
        </div>
      )}

      <div className="row g-3">
        {summary.kpis.map((kpi) => (
          <div className="col-12 col-sm-6 col-lg-3" key={kpi.key || kpi.label}>
            <div className="admin-kpi-card h-100">
              <div className="admin-kpi-body">
                <span
                  className="admin-kpi-icon"
                  style={{
                    backgroundColor: accentMap[kpi.accent]?.bg || "#e5e7eb",
                    color: accentMap[kpi.accent]?.fg || "#0f172a",
                  }}
                >
                  <i className={`bi ${kpi.icon || "bi-circle"} me-0`}></i>
                </span>
                <div className="admin-kpi-text">
                  <p className="admin-kpi-label mb-0">{kpi.label}</p>
                  <div className="admin-kpi-value">
                    {kpi.isMoney ? `$${formatNumber(kpi.value)}` : formatNumber(kpi.value)}
                  </div>
                  <div className="admin-kpi-helper">{kpi.helper}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-3">
        <FinancialTab
          financiero={financiero}
          centros={centros}
          cursos={cursos}
          promociones={promociones}
          globalFilters={{}}
          showKpis={false}
        />
      </div>
    </div>
  );
}
